import React, { useState } from 'react'
import Dropzone from 'react-dropzone'
import { Avatar, Box } from '@mui/material'
import imageService from '../../../services/imageService'
import { useSnackbar } from 'notistack'
import axios from 'axios'
import { useFormContext } from 'react-hook-form'
import BLANK_AVATAR from '../../../images/avatar_blank.png'

const AvatarUploadDropZone = ({ methodName, width, height }) => {
  const methods = useFormContext()
  const avatarImage = methods.watch(methodName)
  const [uploadProgress, setUploadProgress] = useState(0)
  const { enqueueSnackbar } = useSnackbar()
  const acceptedFileTypes = ['image/png', 'image/jpeg', 'image/jpg']
  const {
    register,
    setValue,
    formState: { errors }
  } = methods

  const onDropHandler = acceptedFiles => {
    acceptedFiles.forEach(acceptedFile => {
      if (acceptedFileTypes.includes(acceptedFile.type)) {
        const data = { imageKey: acceptedFile.name }
        imageService.getPresignedUrl(data)
          .then(res => {
            uploadToPresignedUrl(acceptedFile, res.presignedUrl)
              .then(() => {
                enqueueSnackbar('Successfully uploaded your image!', { variant: 'success' })
              })
              .catch((err) => {
                console.log(err)
                enqueueSnackbar('Something went wrong', { variant: 'warning' })
              })
          })
          .catch(err => enqueueSnackbar(err, { variant: 'warning' }))
      } else {
        onDropRejected()
      }
    })
  }

  const onDragOverHandler = () => {
  }

  const onDropRejected = () => {
    enqueueSnackbar('This file type is not allowed', { variant: 'warning' })
  }

  const uploadToPresignedUrl = async (fileToUpload, presignedUrl) => {
    if (!isFileDuplicate(fileToUpload)) {
      const uploadResponse = await axios.put(presignedUrl, fileToUpload, {
        headers: {
          'Content-Type': fileToUpload.type
        },
        onUploadProgress: (progressEvent) => {
          const percentCompleted = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          )
          setUploadProgress(percentCompleted)
          console.log(`Upload Progress: ${percentCompleted}%`)
        }
      })
      setValue(methodName, process.env.REACT_APP_REDDITLIKE_IMAGE_BASE_URL + '/' + uploadResponse.config.data.path)
      register(methodName, process.env.REACT_APP_REDDITLIKE_IMAGE_BASE_URL + '/' + uploadResponse.config.data.path)
    }
  }

  const isFileDuplicate = fileToUpload => {
    let result = false
    if (avatarImage) {
      result = avatarImage.split('/').splice(-1)[0] === fileToUpload.path
    }
    return result
  }

  return (
    <Dropzone onDrop={onDropHandler} onDragOver={onDragOverHandler} onDropRejected={onDropRejected}>
      {({ getRootProps, getInputProps }) => (
        <Box sx={{
          p: 3,
          border: '1px dashed',
          borderColor: 'grey.800',
          borderRadius: 5,
          m: 1
        }}>
          <div {...getRootProps()}>
            <input {...getInputProps()} />
            <>
              {avatarImage
                ? <Avatar sx={{ width, height }} src={avatarImage}/>
                : <Avatar sx={{ width, height }} src={BLANK_AVATAR}/>
              }
            </>
          </div>
        </Box>
      )}
    </Dropzone>
  )
}

export default AvatarUploadDropZone
